import type { SVGProps } from 'react';

// Lucide LayoutDashboard geometry, but rescaled to the nav icon set band:
// lucide draws it 3..21 on the 24 grid (smaller than its own Calendar at
// 2..22), so heights don't line up in the header. 28 grid, stroke 1.75,
// centerline bounds 2.333..25.667 — verified by the measured-bounds table in
// the Icons/HeaderNavIcons story.
const SvgDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2.333" y="2.333" width="9.074" height="11.667" rx="1.296" stroke="currentColor" strokeWidth={1.75} />
    <rect x="16.593" y="2.333" width="9.074" height="6.481" rx="1.296" stroke="currentColor" strokeWidth={1.75} />
    <rect x="16.593" y="14" width="9.074" height="11.667" rx="1.296" stroke="currentColor" strokeWidth={1.75} />
    <rect x="2.333" y="19.185" width="9.074" height="6.481" rx="1.296" stroke="currentColor" strokeWidth={1.75} />
  </svg>
);
export default SvgDashboard;
